/**
 * Single source of truth for per-page SEO meta.
 * Data lives in seo-pages.json so it can be safely loaded by both:
 *   - the React app (this module)
 *   - scripts/seo-postbuild.js (Node, build time)
 * with zero eval() / no parsing risk.
 */
import data from "./seo-pages.json";

export const ORIGIN = "https://peanutfactorystudio.com";

export const SEO_PAGES = data;

/** Get the canonical URL for a route. */
export function canonicalFor(route) {
  return route === "/" ? `${ORIGIN}/` : `${ORIGIN}${route}`;
}

/** Get full SEO config for a route (with canonical built in). */
export function seoFor(route) {
  const meta = SEO_PAGES[route] || SEO_PAGES["/"];
  return { ...meta, canonical: canonicalFor(route) };
}
